import { formatPrice } from "@/utils.js";

export const formatPriceMixin = {
    computed: {
        formatPrice() {
            return price => formatPrice(price) + " DH";
        }
    }
};
